var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "li",
    {
      staticClass:
        "text-primary hover:underline hover:text-primary-600 cursor-pointer",
    },
    [
      _c(
        "a",
        {
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.redirect.apply(null, arguments)
            },
          },
        },
        [_vm._v(" " + _vm._s(_vm.linkTitle) + " ")]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }